import { useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultDiscovery, getWorkflowSteps } from "compid/workflows/BillDiscoveryWorkflow";
import React, { useState } from "react";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";
import UICheckbox from "compid/ui/UICheckbox";

import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import "./styles.css";

/**
 * @function FindMyBillsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for FindMyBillsPage
 * @example
 * <FinMyBillsPage />
 */
export default function FindMyBillsPage(props) {
  const workflowStep = useWorkflowStep(getDefaultDiscovery, getWorkflowSteps);

  const [state, setState] = useState(0);
  const toggleCheck = value => setState(value ? state + 1 : state - 1);

  const skip = evt => workflowStep.navigate("/paybills");
  const next = evt => {

    const { dispatcher, state } = workflowStep.globalController;

    dispatcher("updateModel", { ...state, "profile": { ...state.profile, "agreedToDiscovery": "true" } });
    workflowStep.workflow.nextStep(workflowStep.defaultState);

  };

  const disabled = state === 0 ? "disabled-button" : "";

  return (
    <PageView className="find-my-bills-page">
      <p className="page-sub-header semi-bold-text">FIND MY BILLS</p>

      <PageLayoutContainer>
        <CenterColumnContainer>
          <h2 className="text-center">Let's get started by finding the bills you pay</h2>
          <p className="find-and-add-billers-text text-center bold-text">Find and add billers to your list, bringing all your bills together in one place for easy payments.</p>

          <div className="form-group">
            <div className="terms-and-conditions-container flex-container flex-vertical row-container form-row">
              <div className="disclaimer-1 flex-container flex-horizontal align-center">
                <p className="disclaimer-text gray-text">By checking the box, you are providing your consent to allow our service provider to:</p>
              </div>
              <div className="disclaimer-2 flex-container flex-horizontal">
                <ul className="disclaimer-list gray-text">
                  <li className="list-item gray-text">Match your profile with any bills in our service provider's biller network to help you easily find and add billers you may already be paying.</li>
                  <li className="list-item gray-text">Access your consumer credit report from one or more consumer reporting agencies to help identify bills you pay. The report does not include your credit score and will not impact your credit score. Your information remains confidential and will only be used to identify the bills you pay and is not used for credit decisions or eligibility determinations.</li>
                  <li className="list-item gray-text">Collect data from the National Consumer Telecom and Utilities Exchange (NCTUE), a consumer reporting agency, to show bills related to you–such as telecommunications, home security, and utility services–so you can manage them all in one place.</li>
                </ul>
              </div>
            </div>

            <div className="terms-and-conditions-checkbox-container flex-container flex-horizontal">
              <div className="set-width">
                <UICheckbox className="terms-and-conditions-checkbox" dataPoint="Bill_Discovery_Network_Checkbox" />
              </div>
              <div className="flex-width ">
                <p className="terms-and-conditions-checkbox-label bold-text">I confirm that I have read, and provide consent to the above terms and conditions.</p>
              </div>
            </div>

            <ButtonContainer className="form-button-container">
              <UIButton className="secondary-button" onClick={skip}  dataPoint="Bill_Discovery_Find_Bills_Skip">Skip</UIButton>
              <UIButton className={`primary-button `} onClick={next} dataPoint="Bill_Discovery_Find_Bills">Find my billers</UIButton>
            </ButtonContainer>
          </div>
        </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  );
}